module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/pantone-97254667d5e73397b3a5388539df7e2a.svg";